import { Box, Container, Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

import FaqDetails from '../../../components/Faq/FaqDetails';

const Faq = () => {
  const { t } = useTranslation();
  return (
    <Container
      maxWidth={'lg'}
      sx={{
        py: '40px',
      }}
    >
      <Stack
        sx={{
          display: 'flex',
          justifyContent: 'center',
          flexDirection: 'column',
          gap: 2,
        }}
      >
        <Typography
          variant="h2"
          sx={{ fontSize: '32px', fontWeight: '600', textAlign: 'center' }}
        >
          {t('LANDING_PAGES.EURO_QUALIFIERS.FAQ.TITLE')}
        </Typography>
        <Box sx={{ width: { xs: '100%', md: '70%' }, mx: 'auto' }}>
          <FaqDetails />
        </Box>
      </Stack>
    </Container>
  );
};

export default Faq;
